import api from "../api";
import axios from "axios";
import {
    Subject
} from 'rxjs';

const loanProgress = new Subject();

export default class LoanApplicationService {

    loanProductsubject = new Subject();
    loanChangeOrderrefreshComponent = new Subject();
    loanappliacntsubject = new Subject();
    isproductenable = new Subject();
    isapplicantCreditScore = new Subject();

    sendMessage = message => loanProgress.next({
        text: message
    });
    getMessage = () => loanProgress.asObservable();



    async getAccountNameById(accountId) {
        return await api.get(`Account/GetAccountNameById/${accountId}`);
    }
    async getInstallerRepNameList(salesRepName, accountId, companyId) {
        return await api.get(
            `Opportunity/GetInstallerRepNameList/${salesRepName}/${accountId}/${companyId}`
        );
    }
    async getSalesRepNameList(salesRepName, accountId, companyId) {
        return await api.get(
            `Opportunity/GetSalesRepNameList/${salesRepName}/${accountId}/${companyId}`
        );
    }
    async GetFileUploadSourceNoAuth(file) {
        return await api.get(`Lease/GetFileUploadSourceNoAuth?file=${file}`);
    }
    async saveData(FormJsonData) {
        return await api.post(
            `LoanApplication/GenerateLoanApplication`,
            FormJsonData
        );
    }
    async GetNewLoanApplicationList(
        name,
        sortColumn,
        sortOrder,
        page,
        pageSize,
        type,
        custom_view_id,
        batchid,
        listType,
        userId,
        companyId
    ) {
        if (typeof name == "undefined" || name == null) {
            name = null;
        } else {
            name = encodeURIComponent(name);
        }
        return await api.get(
            `loanApplication/GetNewLoanApplicationList/${name}/${sortColumn}/${sortOrder}/${page}/${pageSize}/${type}/${custom_view_id}/${batchid}/${listType}/${userId}/${companyId}`
        );
    }
    async CheckBankDocumentMapping(companyId, loanProductId) {
        return await api.get(
            `LoanApplication/CheckBankDocumentMapping/${companyId}/${loanProductId}`
        );
    }
    async LoanApplicationContactCheck(email, companyId) {
        return await api.get(
            `LoanApplication/LoanApplicationContactCheck/${email}/${companyId}`
        );
    }
    async addOrUpdateUploadFileOnAzzureNoAuth(CompanySetUpModel) {
        console.log("CompanySetUpModel", CompanySetUpModel);
        return await api.post(
            `LoanApplication/addOrUpdateUploadFileOnAzzureNoAuth`,
            CompanySetUpModel, {
                "Content-Type": "multipart/form-data",
            }
        );
    }

    async getDocumentForReceiveAndPendingforcustomer(
        userId,
        companyid,
        id,
        reqFrom
    ) {
        return await api.get(
            `LoanApplication/getDocumentForReceiveAndPendingForCust/${userId}/${companyid}/${id}/${reqFrom}`
        );
    }


    async getRuleEngineHistoryList(userId, companyId, sortColumn, sortDir, pageNumber, pageSizeValue, loanId) {
        return await api.get(`LoanApplication/GetRuleEngineHistoryList/${userId}/${companyId}/${sortColumn}/${sortDir}/${pageNumber}/${pageSizeValue}/${loanId}`)
    }

    async CheckBankDocumentMapping(companyId, loanProductId) {
        return await api.get(
            `LoanApplication/CheckBankDocumentMapping/${companyId}/${loanProductId}`
        );
    }

    async SaveFile(formData) {
        return await api.post(`LoanApplication/SaveFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };

    async GetAuditHistoryList(sectionId, tableName, userId, companyId, appid) {
        return await api.get(`LoanApplication/GetAuditHistoryList/${sectionId}/${tableName}/${userId}/${companyId}/${appid}`)
    }

    async GetUsertoAssignLoanApplication(
        userId,
        companyId,
        name,
        userType,
        sortColumn,
        sortDir,
        pageNumber,
        pageSizeValue,
        loanapplicationId,
        listType = ""
    ) {;
        if (name == "") {
            name = "null";
        }
        if (userType == "") {
            userType = "null";
        }
        if (listType == "") {
            listType = "null";
        }
        return await api.get(
            `LoanApplication/GetUsertoAssignLoanApplication/${userId}/${companyId}/${name}/${userType}/${sortColumn}/${sortDir}/${pageNumber}/${pageSizeValue}/${loanapplicationId}/${listType}`
        );
        //return await axios.get('../LoanApplicationList.json');
    }

    async saveAssignedSalesUserDetail(bankermodel) {
        return await api.post(
            `LoanApplication/saveAssignedSalesUserDetail`,
            bankermodel
        );
    }

    async GetbankApplicantInfo(id, companyId, userId) {
        return await api.get(
            `LoanApplication/GetbankApplicantInfo/${id}/${companyId}/${userId}`
        );
    }
    async GetLoanProductInfo(id, companyId, userId, subModuleName) {
        return await api.get(
            `LoanApplication/GetLoanProductInfo/${id}/${companyId}/${userId}/${subModuleName}`
        );
    }
    async GetApplicationDetails(userId,companyId,applicationid) {
        return await api.get(
            `LoanApplication/applicationinfo/${userId}/${companyId}/${applicationid}`
        );
    }

    async GetLoanapplicationDocumentTypeforcust(userId, companyid, id) {
        if (id == null) {
            id = "";
        }
        return await api.get(
            `LoanApplication/GetLoanapplicationDocumentTypeforcust/${userId}/${companyid}/${id}`
        );
    }

    async GetLoanapplicationDocumentTypeforcust(userId, companyid, id) {
        if (id == null) {
            id = "";
        }
        return await api.get(
            `LoanApplication/GetLoanapplicationDocumentTypeforcust/${userId}/${companyid}/${id}`
        );
    }

    async customeruploadfilePDF(CompanySetUpModel) {
        return await api.post(
            `LoanApplication/customeruploadfilePDF`,
            CompanySetUpModel, {
                "Content-Type": "multipart/form-data",
            }
        );
    }

    async GetLoanApplicationById(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetLoanApplicationById/${loanApplicationId}/${userId}/${companyId}`
        );
    }

    async GetLoanApplicationSalesRep(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetLoanApplicationSalesRep/${loanApplicationId}/${userId}/${companyId}`
        );
    }

    async GetLoanApplicationStagesById(loanApplicationId, userId, companyId) {

        return await api.get(
            `LoanApplication/GetLoanApplicationStagesById/${loanApplicationId}/${userId}/${companyId}`
        );
    }

    async GetFormFieldsData(
        companyId,
        userId,
        moduleName,
        subModuleName,
        Id,
        strType,
        search,
        isRef,
        PrimaryId,
        displayCode,
        formMasterId,
        isFor
    ) {
        return await api.get(
            `LoanApplication/GetFormFieldsData/${companyId}/${userId}/${moduleName}/${subModuleName}/${Id}/${strType}/${search}/${isRef}/${PrimaryId}/${displayCode}/${formMasterId}/${isFor}`
        );
    }

    async addEditForm(dataModel) {
        return await api.post(`LoanApplication/AddUpdateSystemInfo`, dataModel);
    }

    async GetFileuploadImages(
        loanApplicationId,
        subModuleCode,
        companyId,
        userId
    ) {
        return await api.get(
            `LoanApplication/GetFileuploadImages/${loanApplicationId}/${subModuleCode}/${companyId}/${userId}`
        );
    }


    async GetPath(url) {
        return await api.post(`LoanApplication/GetFile`, url, {
            responseType: "blob"
        });
    }

    async Deleteimage(id, userId, companyId) {
            return await api.get(
                `LoanApplication/Deleteimage/${id}/${userId}/${companyId}`
            );
        }
        // async GetDecryptid(encryptid) {
        //   return await api.get(`LoanApplication/GetDecryptid?encryptid=${encryptid}`);
        // }

    async GetFileuploadImages(loanApplicationId, subModuleCode, companyId, userId) {
        return await api.get(`LoanApplication/GetFileuploadImages/${loanApplicationId}/${subModuleCode}/${companyId}/${userId}`)
    }

    async GetCreditScoreByLoanApplicationId(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetCreditScoreByLoanApplicationId/${loanApplicationId}/${userId}/${companyId}`
        );
    }
    async GetExpensesIncomeList(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetExpensesIncomeList/${loanApplicationId}/${userId}/${companyId}`
        );
    }
    async GetExpensesDebitList(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetExpensesDebtList/${loanApplicationId}/${userId}/${companyId}`
        );
    }
    async GetExpensesRatiosList(loanApplicationId, userId, companyId) {
        return await api.get(
            `LoanApplication/GetExpensesRatiosList/${loanApplicationId}/${userId}/${companyId}`
        );
    }

    // async GetDecryptid(encryptid) {
    //   return await api.get(`LoanApplication/GetDecryptid?encryptid=${encryptid}`);
    // }



    async saveReason(reason) {
        return await api.post(`LoanApplication/saveReason`, reason);
    }

    async SaveUnCancelReason(reason) {
        return await api.post(`LoanApplication/UncancelLoanApplication`, reason);
    }

    async SendToBankUser(id, applicationNumber, reason, reqdate, userId, companyId) {
        return await api.get(`LoanApplication/SendToBankUser/${id}/${applicationNumber}/${reason}/${reqdate}/${userId}/${companyId}`);
    }

    async GetCreditBureauHistoryListByLoanApplicationId(userid, companyid, sortDir, sortColumn, pageNumber, pageSizeValue, loanapplicationId) {
        return await api.get(`LoanApplication/GetCreditBureauHistoryListByLoanApplicationId/${userid}/${companyid}/${sortDir}/${sortColumn}/${pageNumber}/${pageSizeValue}/${loanapplicationId}`);
    };
    async GetCommentHistoryList(userid, companyid, sortDir, sortColumn, pageNumber, pageSizeValue, loanapplicationId) {
        return await api.get(`LoanApplication/GetCommentHistoryList/${userid}/${companyid}/${sortDir}/${sortColumn}/${pageNumber}/${pageSizeValue}/${loanapplicationId}`);
    };
    async SaveAddComment(dataModel) {
        return await api.post(`LoanApplication/SaveAddComment`, dataModel);
    };

    async saveAssignedApplicationToDealer(transferLoanAppModel) {
        return await api.post(`LoanApplication/saveAssignedApplicationToDealer`, transferLoanAppModel);
    }

    async saveOverrideReason(reason) {

        return await api.post(`LoanApplication/saveOverrideReason`, reason);
    }

    async SwapApplicants(loanId, userId, companyId) {
        return await api.get(`LoanApplication/SwapApplicants/${loanId}/${userId}/${companyId}`)
    }

    async pullCreditScoreData(loanApplicationId, applicants, bureauId, userid, companyid) {
        return await api.get(`CreditScore/PullCreditScoreData/${loanApplicationId}/${applicants}/${bureauId}/${userid}/${companyid}`);
    }

    async getCreditBureauList(userid, companyid) {
        return await api.get(`CreditScore/GetCreditBuearuList/${userid}/${companyid}`);
    }


    async getDocumentForReceiveAndPending(UserId, CompanyId, productId) {
        return await api.get(`LoanApplication/getDocumentForReceiveAndPending/${UserId}/${CompanyId}/${productId}`);
    }


    async ShareDocLink(id, type, borrowerPhoneNumber, applicantName) {
        return await api.get(`LoanApplication/ShareLink/${id}/${type}/${borrowerPhoneNumber}/${applicantName}`)
    }

    async getLoanDocslist(loanId, sortColumn, sortDir, pageNumber, pageSize, UserId, CompanyId) {
        return await api.get(`LoanDocumentHistory/GetDocumentHistoryList/${loanId}/${sortColumn}/${sortDir}/${pageNumber}/${pageSize}/${UserId}/${CompanyId}`);
    }

    async GetSignNowDocumentHistory(document_id, CompanyId) {
        return await api.get(`WebMerge/GetSignNowDocumentHistory/${document_id}/${CompanyId}`)
    }

    async GetDocusignDocumentHistory(document_id, CompanyId) {
        return await api.get(`WebMerge/GetDocusignDocumentHistory/${document_id}/${CompanyId}`)
    }

    async DownloadBankDocument(documentId, SourceType, SolgenFileUrl, LoanAppId, companyId) {
        return await api.get(`WebMerge/DownloadBankDocument/${documentId}/${SourceType}/${SolgenFileUrl}/${LoanAppId}/${companyId}`, {
            responseType: 'blob'
        })
    }

    async DownloadFile(loanApplicationId, historyId) {
        return await api.get(`LoanDocumentHistory/DownloadFile/${loanApplicationId}/${historyId}`, {
            responseType: 'blob'
        })
    }

    async voidDocuments(loanApplicationId, resend, CompanyId, UserId) {
        return await api.get(`LoanDocumentHistory/VoidDocuments/${loanApplicationId}/${resend}/${CompanyId}/${UserId}`);
    }

    async getBankIdByLoanApplicationId(loanApplicationId) {
        return await api.get(`WebMerge/GetBankIdByLoanApplicationId/${loanApplicationId}`);
    }

    async mergeWebmergeMapping(LoanApplicationId, bankId, companyId, userId, IsChangeOrder = false, SignerBy = null) {
        return await api.get(`WebMerge/MergeWebmergeMapping/${LoanApplicationId}/${bankId}/${companyId}/${userId}/${IsChangeOrder}/${SignerBy}`,{timeout:0});
    }

    async UpdateLoanHistoryManual(bankId, historyId, loanApplicationId, companyId, UserId, IsChangeOrder, data) {
        console.log("UpdateLoanHistoryManual", data)
        return await api.post(`LoanDocumentHistory/UpdateLoanHistoryManual/${bankId}/${historyId}/${loanApplicationId}/${companyId}/${UserId}/${IsChangeOrder}`, data, {
            "Content-Type": "multipart/form-data",
        })
    }


    async getNoticationList(applicationid, sortColumn, sortDir, pageNumber, pageSizeValue, from = 'null', userid, companyId) {

        return await api.get(`LoanApplication/GetLoanapplicationNotificationList/${applicationid}/${sortColumn}/${sortDir}/${pageNumber}/${pageSizeValue}/${from}/${userid}/${companyId}`)
    }

    async GettemplatetDll(objectname, userId, companyId) {
        return [{
            "masterName": null,
            "text": "Share Document - Applicant",
            "value": "445CE818-3970-453D-8751-B2700FA14342",
            "email": null,
            "name": null,
            "first_value": null,
            "second_value": null,
            "third_value": null,
            "recordType": null,
            "type": null,
            "requiredByName": null,
            "requiredBy": null,
            "valueGuid": null,
            "description": null,
            "accountId": null,
            "timeSlots": null,
            "operatingHourTimeZone": null
        }]

        //return await api.get(`LoanApplication/GettemplatetDll/${objectname}/${userId}/${companyId}`)
    }

    async GetContactDll(loanId, userId, companyId, isPrivate) {

        return await api.get(`LoanApplication/GetToUserDrpList/${loanId}/${userId}/${companyId}/${isPrivate}`)
    }

    async getCCUserdll(userId, companyId) {
        return await api.get(`LoanApplication/GetCCUserDrpList/${userId}/${companyId}`)
    }
    async GetLoanDocumentHistory(applicationid, sortColumn, sortDir, pageNumber, pageSizeValue, userId, companyId) {
            return await api.get(`LoanApplication/GetLoanDocumentHistory/${applicationid}/${sortColumn}/${sortDir}/${pageNumber}/${pageSizeValue}/${userId}/${companyId}`);
        }
        //string companyId, string userId, string moduleName, string Id, string stageid, string PrimaryId
    async GetDataForVerificationList(companyId, userId, moduleName, Id, stageid, PrimaryId) {
        return await api.get(`LoanApplication/GetDataForVerificationList/${companyId}/${userId}/${moduleName}/${Id}/${stageid}/${PrimaryId}`);
    }
    async AddUpdateVerificationData(dataModel) {
        return await api.post(`LoanApplication/AddUpdateVerificationData`, dataModel);
    }

    async SendManualNotification(model) {
        return await api.post(`LoanApplication/SendManualNotification`, model);
    }

    async GetbankApplicantInfo(id, companyId, userId) {
        return await api.get(`LoanApplication/GetbankApplicantInfo/${id}/${companyId}/${userId}`)
    }


    async GetStageLoanApplicationId(loanApplicationId) {
        return await api.get(`LoanApplication/GetStageLoanApplicationId/${loanApplicationId}`);
    }

    async GetDataForBankVerificationList(companyId, userid, Id, stageid) {
        return await api.get(`LoanApplication/GetDataForBankVerificationList/${companyId}/${userid}/${Id}/${stageid}`);
    }

    async addEditbankverificationdata(JsonData) {
        return await api.post(`LoanApplication/AddUpdateBankdata`, JsonData);
    }

    async GetFundingValues(Id) {
        return await api.get(`LoanApplication/GetFundingValues/${Id}`)
    }

    ///=========================== Ntp start ============================================///

    async GetChangeOrderInfoById(id, userId, companyId) {
        return await api.get(`LoanApplication/GetChangeOrderInfoById/${id}/${userId}/${companyId}`)
    }

    async GetFileSource(companyId, userid, loanid, type) {
        return await api.get(`LoanApplication/GetFileSource/${companyId}/${userid}/${loanid}/${type}`);
    }

    // async addEditForm(JsonData) {
    //     return await api.post(`LoanApplication/AddUpdateSystemInfo`, JsonData);
    //   }

    // async GetStageLoanApplicationId(loanApplicationId) {
    //     return await api.get(`LoanApplication/GetStageLoanApplicationId/${loanApplicationId}`);
    // }

    ///=========================== Ntp end ============================================///

    async addEditInstallStep(JsonData) {
        return await api.post(`LoanApplication/AddUpdateInstallStepForm`, JsonData, {
            "Content-Type": "multipart/form-data",
        });
    }

    async addEditFormDynamic(JsonData) {
        return await api.post(`LoanApplication/AddUpdateDynamicForm`, JsonData);
    }

    async GetAuditHistoryDetail(id1, id2, tblName1, tblName2, appid,userId,companyId) {
        return await api.get(`LoanApplication/GetAuditHistoryDetail/${id1}/${id2}/${tblName1}/${tblName2}/${appid}/${userId}/${companyId}`)
    }
    
    async getTotalDTI(applicationid,userId,companyId) {
      return await api.get(`LoanApplication/GetTotalDTI/${applicationid}/${userId}/${companyId}`)
    }

    async GetStageDetails(userId,companyId,applicationid) {
        return await api.get(`LoanApplication/loanstages/${userId}/${companyId}/${applicationid}`)
    }

    async GetProductData(companyId, Id, loanid) {
        return await api.get(`LoanProduct/GetLoanProductDetailById/${Id}/${companyId}/${loanid}`)
    }
}

export class JsonData {
    Id;
    FormJsonData;
    moduleCode;
    subModuleCode;
    companyId;
    userId;
    leadconvert;
    leadid;
    docDate;
    isForChangeOrder;
    StageName;
    SFOpportunityId;
    ApplicationNumber;
    SourceType;
    DealerName;
    FormMasterId;
    constructor() {
      this.Id = null;
      this.FormJsonData = null;
      this.moduleCode = null;
      this.subModuleCode = null;
      this.companyId = null;
      this.userId = null;
      this.leadconvert = null;
      this.leadid = null;
      this.docDate = null;
      this.isForChangeOrder = null;
      this.StageName = null;
      this.SFOpportunityId = null;
      this.ApplicationNumber = null;
      this.SourceType = null;
      this.DealerName = null;
      this.FormMasterId = null;
    }
  }


export class LoanProgressModel {
    appyingChanges;
    applyingRules;
    finalizing;
    result;
    callBackFunction = function() {};

    constructor() {
        this.appyingChanges = Progress.stop;
        this.applyingRules = Progress.stop;
        this.finalizing = Progress.stop;
        this.callBackFunction = function() {};
    }
}


export const Progress = Object.freeze({
    stop: 0,
    start: 1,
    completed: 2,
    failed: 3,
})